import { render } from "./MainHero.vue?vue&type=template&id=1abb04a7&scoped=true"
const script = {}

import "./MainHero.vue?vue&type=style&index=0&id=1abb04a7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1abb04a7"]])

export default __exports__